// Since our default is en, we check it as it should contain any
// requested key even if another language doe not.
import en from '@/assets/locales/en.json';

export function stateTranslationKey(baseKey, stateAbbrev) {
  if (!stateAbbrev) return baseKey;
  const state = String(stateAbbrev).toUpperCase();
  return `${baseKey}.${state}`;
}

export function hasTranslation(key) {
  return Object.prototype.hasOwnProperty.call(en, key);
}

/**
 * @param {Function} t - typically this.$t
 * @param {string} baseKey
 * @param {string} stateAbbrev
 * @param {object} [params]
 */
export function tState(t, baseKey, stateAbbrev, params) {
  const stateKey = stateTranslationKey(baseKey, stateAbbrev);
  if (stateAbbrev && hasTranslation(stateKey)) {
    return t(stateKey, params);
  }
  return t(baseKey, params);
}